// extracted by mini-css-extract-plugin
export default {"inputText":"style_inputText__Q4vts"};